import { render, staticRenderFns } from "./AdminTradeCom.vue?vue&type=template&id=4d133d16&scoped=true&"
import script from "./AdminTradeCom.vue?vue&type=script&lang=js&"
export * from "./AdminTradeCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d133d16",
  null
  
)

export default component.exports